import { render, staticRenderFns } from "./RotateText.vue?vue&type=template&id=a0fc7ee6&scoped=true&"
import script from "./RotateText.vue?vue&type=script&lang=js&"
export * from "./RotateText.vue?vue&type=script&lang=js&"
import style0 from "./RotateText.vue?vue&type=style&index=0&id=a0fc7ee6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0fc7ee6",
  null
  
)

export default component.exports